import * as React from "react";
import Link from "./Link";

const TYPE_TO_CLASSNAME = {
  primary:
    "flex-grow-0 flex items-center justify-center mx-auto w-fit px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-action-600 hover:bg-action-700",
  secondary:
    "flex-grow-0 flex items-center justify-center mx-auto w-fit px-5 py-3 border border-transparent text-base font-medium rounded-md text-action-700 bg-action-100 hover:bg-action-200",
};

export const Button = ({
  text,
  href,
  type = "primary",
  className: classNameProp,
}) => {
  const className = TYPE_TO_CLASSNAME[type] || TYPE_TO_CLASSNAME.primary;

  return (
    <Link
      href={href}
      className={[classNameProp, className].filter(Boolean).join(" ")}
    >
      {text}
    </Link>
  );
};
